import { GET_FOOTER_DATE, GET_SOS_CLAIM_EVENT_DATA, GET_SOS_CLAIM_EVENT_DATA_SUCCESS, IS_LOADING,
   MARKET_SHARE_DATA_SUCESS, SET_MARKET_SHARE_DATA , GET_SOS_PROGRAM_DATA} from "../actions/actionTypes";


interface SiteOfServiceState {
  sosClaimEventData: any;
  sosProgramData: any;
  timePeriod:any;
  isLoading:Boolean;
  marketShareTrendData:any;
  marketShareTrendDataSuccess:Boolean
}

const initialState: SiteOfServiceState = {
  sosClaimEventData: {},
  sosProgramData: {},
  timePeriod:'',
  isLoading:false,
  marketShareTrendData:{},
  marketShareTrendDataSuccess:false
};

const siteOfServiceReducer = (state = initialState, action: { type: string; payload?: any }): SiteOfServiceState => {
  switch (action.type) {
    case GET_SOS_CLAIM_EVENT_DATA_SUCCESS:
      return {
        ...state,
        sosClaimEventData: action.payload,
      };
    case GET_SOS_CLAIM_EVENT_DATA:
      return {
        ...state,
        sosClaimEventData: action.payload,
      };
      case GET_SOS_PROGRAM_DATA:
        return {
          ...state,
          sosProgramData:  action.payload,
        };
      case GET_FOOTER_DATE:
        return {
          ...state,
          timePeriod: action.payload,
        };
        case IS_LOADING:
          return {
            ...state,
            isLoading: action.payload,
          };

        
        //market share data
        case MARKET_SHARE_DATA_SUCESS:
          return {
            ...state,
            marketShareTrendDataSuccess: action.payload,
          };
          case SET_MARKET_SHARE_DATA:
            return {
              ...state,
              marketShareTrendData: action.payload,
            };
    default:
      return state;
  }
};

export default siteOfServiceReducer;



